<mat-card class="pageWrapper">
    <mat-card-content>
        <div class="mat-elevation-z8 section-wrap">
            <div class="page-title-wrap">
                <h2 class="page-title">
                    Add New Assessment
                </h2>
            </div>
            <div class="form-wrap">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select Course Test Name</mat-label>
                    <mat-select (selectionChange)="getAssessmentId()" [(ngModel)]="addAssessmentReqObj.testNameId"
                        name="testNameId">
                        <mat-option *ngFor="let assessmentName of assessmentNameList"
                            [value]="assessmentName.id">{{assessmentName.testName}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select Assessment Id</mat-label>
                    <mat-select (selectionChange)="getTopicId()" [(ngModel)]="addAssessmentReqObj.testId" name="testId"
                        [disabled]="addAssessmentReqObj.newTestId.length != 0">
                        <mat-option [value]=0></mat-option>
                        <mat-option *ngFor="let assessmentID of assessmentIDList"
                            [value]="assessmentID.id">{{assessmentID.testId}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="or-text">
                    OR
                </div>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Specify Assessment name</mat-label>
                    <input matInput [(ngModel)]="addAssessmentReqObj.newTestId" name="newTestId"
                        [disabled]="addAssessmentReqObj.testId != 0">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select Topic Id</mat-label>
                    <mat-select [(ngModel)]="addAssessmentReqObj.topicId" name="topicId"
                        [disabled]="addAssessmentReqObj.newTopicId.length != 0">
                        <mat-option [value]=0></mat-option>
                        <mat-option *ngFor="let topicID of topicIDList" [value]="topicID.id">{{topicID.id}}
                            {{topicID.topicId}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="or-text">
                    OR
                </div>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Topic name</mat-label>
                    <input matInput [(ngModel)]="addAssessmentReqObj.newTopicId" name="newTopicId"
                        [disabled]="addAssessmentReqObj.topicId != 0">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Specify Course Id</mat-label>
                    <input matInput [(ngModel)]="addAssessmentReqObj.newCourseId" name="newCourseId">
                </mat-form-field>
                <button mat-raised-button class="button-style" (click)="addAssessment()">Submit</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>